import { render, staticRenderFns } from "./ChatAction.vue?vue&type=template&id=790463ac&scoped=true"
import script from "./ChatAction.vue?vue&type=script&lang=ts"
export * from "./ChatAction.vue?vue&type=script&lang=ts"
import style0 from "./ChatAction.vue?vue&type=style&index=0&id=790463ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790463ac",
  null
  
)

export default component.exports